export const STATE_CITY_MAP: Record<string, string[]> = {
  "Andhra Pradesh": [
    "Anakapalli",
    "Anantapur",
    "Annamayya",
    "Bapatla",
    "Chittoor",
    "Dr. B.R. Ambedkar Konaseema",
    "East Godavari",
    "Eluru",
    "Guntur",
    "Kakinada",
    "Krishna",
    "Kurnool",
    "Nandyal",
    "NTR",
    "Palnadu",
    "Parvathipuram Manyam",
    "Prakasam",
    "Sri Potti Sriramulu Nellore",
    "Sri Sathya Sai",
    "Srikakulam",
    "Tirupati",
    "Visakhapatnam",
    "Vizianagaram",
    "West Godavari",
    "YSR Kadapa",
  ],
  "Arunachal Pradesh": [
    "Anjaw",
    "Changlang",
    "Dibang Valley",
    "East Kameng",
    "East Siang",
    "Kamle",
    "Kra Daadi",
    "Kurung Kumey",
    "Lepa Rada",
    "Lohit",
    "Longding",
    "Lower Dibang Valley",
    "Lower Siang",
    "Lower Subansiri",
    "Namsai",
    "Pakke Kessang",
    "Papum Pare",
    "Shi Yomi",
    "Siang",
    "Tawang",
    "Tirap",
    "Upper Siang",
    "Upper Subansiri",
    "West Kameng",
    "West Siang",
  ],
  Assam: [
    "Baksa",
    "Barpeta",
    "Biswanath",
    "Bongaigaon",
    "Cachar",
    "Charaideo",
    "Chirang",
    "Darrang",
    "Dhemaji",
    "Dhubri",
    "Dibrugarh",
    "Dima Hasao",
    "Goalpara",
    "Golaghat",
    "Hailakandi",
    "Hojai",
    "Jorhat",
    "Kamrup",
    "Kamrup Metropolitan",
    "Karbi Anglong",
    "Karimganj",
    "Kokrajhar",
    "Lakhimpur",
    "Majuli",
    "Morigaon",
    "Nagaon",
    "Nalbari",
    "Sivasagar",
    "Sonitpur",
    "South Salmara-Mankachar",
    "Tamulpur",
    "Tinsukia",
    "Udalguri",
    "West Karbi Anglong",
  ],
  Bihar: [
    "Araria",
    "Arwal",
    "Aurangabad",
    "Banka",
    "Begusarai",
    "Bhagalpur",
    "Bhojpur",
    "Buxar",
    "Darbhanga",
    "East Champaran",
    "Gaya",
    "Gopalganj",
    "Jamui",
    "Jehanabad",
    "Kaimur",
    "Katihar",
    "Khagaria",
    "Kishanganj",
    "Lakhisarai",
    "Madhepura",
    "Madhubani",
    "Munger",
    "Muzaffarpur",
    "Nalanda",
    "Nawada",
    "Patna",
    "Purnia",
    "Rohtas",
    "Saharsa",
    "Samastipur",
    "Saran",
    "Sheikhpura",
    "Sheohar",
    "Sitamarhi",
    "Siwan",
    "Supaul",
    "Vaishali",
    "West Champaran",
  ],
  Chhattisgarh: [
    "Balod",
    "Baloda Bazar",
    "Balrampur",
    "Bastar",
    "Bemetara",
    "Bijapur",
    "Bilaspur",
    "Dantewada",
    "Dhamtari",
    "Durg",
    "Gariaband",
    "Gaurela-Pendra-Marwahi",
    "Janjgir-Champa",
    "Jashpur",
    "Kabirdham",
    "Kanker",
    "Khairagarh-Chhuikhadan-Gandai",
    "Kondagaon",
    "Korba",
    "Korea",
    "Mahasamund",
    "Manendragarh-Chirmiri-Bharatpur",
    "Mohla-Manpur-Ambagarh Chowki",
    "Mungeli",
    "Narayanpur",
    "Raigarh",
    "Raipur",
    "Rajnandgaon",
    "Sakti",
    "Sarangarh-Bilaigarh",
    "Sukma",
    "Surajpur",
    "Surguja",
  ],
  Goa: ["North Goa", "South Goa"],
  Gujarat: [
    "Ahmedabad",
    "Amreli",
    "Anand",
    "Aravalli",
    "Banaskantha",
    "Bharuch",
    "Bhavnagar",
    "Botad",
    "Chhota Udaipur",
    "Dahod",
    "Dang",
    "Devbhoomi Dwarka",
    "Gandhinagar",
    "Gir Somnath",
    "Jamnagar",
    "Junagadh",
    "Kheda",
    "Kutch",
    "Mahisagar",
    "Mehsana",
    "Morbi",
    "Narmada",
    "Navsari",
    "Panchmahal",
    "Patan",
    "Porbandar",
    "Rajkot",
    "Sabarkantha",
    "Surat",
    "Surendranagar",
    "Tapi",
    "Vadodara",
    "Valsad",
  ],
  Haryana: [
    "Ambala",
    "Bhiwani",
    "Charkhi Dadri",
    "Faridabad",
    "Fatehabad",
    "Gurugram",
    "Hisar",
    "Jhajjar",
    "Jind",
    "Kaithal",
    "Karnal",
    "Kurukshetra",
    "Mahendragarh",
    "Nuh",
    "Palwal",
    "Panchkula",
    "Panipat",
    "Rewari",
    "Rohtak",
    "Sirsa",
    "Sonipat",
    "Yamunanagar",
  ],
  "Himachal Pradesh": [
    "Bilaspur",
    "Chamba",
    "Hamirpur",
    "Kangra",
    "Kinnaur",
    "Kullu",
    "Lahaul and Spiti",
    "Mandi",
    "Shimla",
    "Sirmaur",
    "Solan",
    "Una",
  ],
  Jharkhand: [
    "Bokaro",
    "Chatra",
    "Deoghar",
    "Dhanbad",
    "Dumka",
    "East Singhbhum",
    "Garhwa",
    "Giridih",
    "Godda",
    "Gumla",
    "Hazaribagh",
    "Jamtara",
    "Khunti",
    "Koderma",
    "Latehar",
    "Lohardaga",
    "Pakur",
    "Palamu",
    "Ramgarh",
    "Ranchi",
    "Sahebganj",
    "Seraikela Kharsawan",
    "Simdega",
    "West Singhbhum",
  ],
  Karnataka: [
    "Bagalkot",
    "Ballari",
    "Belagavi",
    "Bengaluru Rural",
    "Bengaluru Urban",
    "Bidar",
    "Chamarajanagar",
    "Chikkaballapur",
    "Chikkamagaluru",
    "Chitradurga",
    "Dakshina Kannada",
    "Davanagere",
    "Dharwad",
    "Gadag",
    "Hassan",
    "Haveri",
    "Kalaburagi",
    "Kodagu",
    "Kolar",
    "Koppal",
    "Mandya",
    "Mysuru",
    "Raichur",
    "Ramanagara",
    "Shivamogga",
    "Tumakuru",
    "Udupi",
    "Uttara Kannada",
    "Vijayanagara",
    "Yadgir",
  ],
  Kerala: [
    "Alappuzha",
    "Ernakulam",
    "Idukki",
    "Kannur",
    "Kasaragod",
    "Kollam",
    "Kottayam",
    "Kozhikode",
    "Malappuram",
    "Palakkad",
    "Pathanamthitta",
    "Thiruvananthapuram",
    "Thrissur",
    "Wayanad",
  ],
  "Madhya Pradesh": [
    "Agar Malwa",
    "Alirajpur",
    "Anuppur",
    "Ashoknagar",
    "Balaghat",
    "Barwani",
    "Betul",
    "Bhind",
    "Bhopal",
    "Burhanpur",
    "Chhatarpur",
    "Chhindwara",
    "Damoh",
    "Datia",
    "Dewas",
    "Dhar",
    "Dindori",
    "Guna",
    "Gwalior",
    "Harda",
    "Hoshangabad",
    "Indore",
    "Jabalpur",
    "Jhabua",
    "Katni",
    "Khandwa",
    "Khargone",
    "Maihar",
    "Mandla",
    "Mandsaur",
    "Morena",
    "Narsinghpur",
    "Neemuch",
    "Niwari",
    "Panna",
    "Raisen",
    "Rajgarh",
    "Ratlam",
    "Rewa",
    "Sagar",
    "Satna",
    "Sehore",
    "Seoni",
    "Shahdol",
    "Shajapur",
    "Sheopur",
    "Shivpuri",
    "Sidhi",
    "Singrauli",
    "Tikamgarh",
    "Ujjain",
    "Umaria",
    "Vidisha",
  ],
  Maharashtra: [
    "Ahmednagar",
    "Akola",
    "Amravati",
    "Aurangabad",
    "Beed",
    "Bhandara",
    "Buldhana",
    "Chandrapur",
    "Dhule",
    "Gadchiroli",
    "Gondia",
    "Hingoli",
    "Jalgaon",
    "Jalna",
    "Kolhapur",
    "Latur",
    "Mumbai City",
    "Mumbai Suburban",
    "Nagpur",
    "Nanded",
    "Nandurbar",
    "Nashik",
    "Osmanabad",
    "Palghar",
    "Parbhani",
    "Pune",
    "Raigad",
    "Ratnagiri",
    "Sangli",
    "Satara",
    "Sindhudurg",
    "Solapur",
    "Thane",
    "Wardha",
    "Washim",
    "Yavatmal",
  ],
  Odisha: [
    "Angul",
    "Balangir",
    "Balasore",
    "Bargarh",
    "Bhadrak",
    "Boudh",
    "Cuttack",
    "Deogarh",
    "Dhenkanal",
    "Gajapati",
    "Ganjam",
    "Jagatsinghpur",
    "Jajpur",
    "Jharsuguda",
    "Kalahandi",
    "Kandhamal",
    "Kendrapara",
    "Kendujhar",
    "Khordha",
    "Koraput",
    "Malkangiri",
    "Mayurbhanj",
    "Nabarangpur",
    "Nayagarh",
    "Nuapada",
    "Puri",
    "Rayagada",
    "Sambalpur",
    "Subarnapur",
    "Sundargarh",
  ],
  Punjab: [
    "Amritsar",
    "Barnala",
    "Bathinda",
    "Faridkot",
    "Fatehgarh Sahib",
    "Fazilka",
    "Ferozepur",
    "Gurdaspur",
    "Hoshiarpur",
    "Jalandhar",
    "Kapurthala",
    "Ludhiana",
    "Malerkotla",
    "Mansa",
    "Moga",
    "Muktsar",
    "Pathankot",
    "Patiala",
    "Rupnagar",
    "Sangrur",
    "SAS Nagar",
    "Shaheed Bhagat Singh Nagar",
    "Tarn Taran",
  ],
  Rajasthan: [
    "Ajmer",
    "Alwar",
    "Anupgarh",
    "Balotra",
    "Banswara",
    "Baran",
    "Barmer",
    "Beawar",
    "Bharatpur",
    "Bhilwara",
    "Bikaner",
    "Bundi",
    "Chittorgarh",
    "Churu",
    "Dausa",
    "Deeg",
    "Didwana-Kuchaman",
    "Dholpur",
    "Dungarpur",
    "Gangapur City",
    "Hanumangarh",
    "Jaipur",
    "Jaisalmer",
    "Jalore",
    "Jhalawar",
    "Jhunjhunu",
    "Jodhpur",
    "Karauli",
    "Kekri",
    "Khairthal-Tijara",
    "Kota",
    "Kotputli-Behror",
    "Nagaur",
    "Neem Ka Thana",
    "Pali",
    "Phalodi",
    "Pratapgarh",
    "Rajsamand",
    "Salumbar",
    "Sanchore",
    "Sawai Madhopur",
    "Shahpura",
    "Sikar",
    "Sirohi",
    "Sri Ganganagar",
    "Tonk",
    "Udaipur",
  ],
  "Tamil Nadu": [
    "Ariyalur",
    "Chengalpattu",
    "Chennai",
    "Coimbatore",
    "Cuddalore",
    "Dharmapuri",
    "Dindigul",
    "Erode",
    "Kallakurichi",
    "Kanchipuram",
    "Kanyakumari",
    "Karur",
    "Krishnagiri",
    "Madurai",
    "Mayiladuthurai",
    "Nagapattinam",
    "Namakkal",
    "Nilgiris",
    "Perambalur",
    "Pudukkottai",
    "Ramanathapuram",
    "Ranipet",
    "Salem",
    "Sivaganga",
    "Tenkasi",
    "Thanjavur",
    "Theni",
    "Thoothukudi",
    "Tiruchirappalli",
    "Tirunelveli",
    "Tirupattur",
    "Tiruppur",
    "Tiruvallur",
    "Tiruvannamalai",
    "Tiruvarur",
    "Vellore",
    "Viluppuram",
    "Virudhunagar",
  ],
  Telangana: [
    "Adilabad",
    "Bhadradri Kothagudem",
    "Hanamkonda",
    "Hyderabad",
    "Jagtial",
    "Jangaon",
    "Jayashankar Bhupalpally",
    "Jogulamba Gadwal",
    "Kamareddy",
    "Karimnagar",
    "Khammam",
    "Komaram Bheem",
    "Mahabubabad",
    "Mahabubnagar",
    "Mancherial",
    "Medak",
    "Medchal–Malkajgiri",
    "Mulugu",
    "Nagarkurnool",
    "Nalgonda",
    "Narayanpet",
    "Nirmal",
    "Nizamabad",
    "Peddapalli",
    "Rajanna Sircilla",
    "Rangareddy",
    "Sangareddy",
    "Siddipet",
    "Suryapet",
    "Vikarabad",
    "Wanaparthy",
    "Warangal",
    "Yadadri Bhuvanagiri",
  ],
  "Uttar Pradesh": [
    "Agra",
    "Aligarh",
    "Ambedkar Nagar",
    "Amethi",
    "Amroha",
    "Auraiya",
    "Ayodhya",
    "Azamgarh",
    "Baghpat",
    "Bahraich",
    "Ballia",
    "Balrampur",
    "Banda",
    "Barabanki",
    "Bareilly",
    "Basti",
    "Bhadohi",
    "Bijnor",
    "Budaun",
    "Bulandshahr",
    "Chandauli",
    "Chitrakoot",
    "Deoria",
    "Etah",
    "Etawah",
    "Farrukhabad",
    "Fatehpur",
    "Firozabad",
    "Gautam Buddha Nagar",
    "Ghaziabad",
    "Ghazipur",
    "Gonda",
    "Gorakhpur",
    "Hamirpur",
    "Hapur",
    "Hardoi",
    "Hathras",
    "Jalaun",
    "Jaunpur",
    "Jhansi",
    "Kannauj",
    "Kanpur Dehat",
    "Kanpur Nagar",
    "Kasganj",
    "Kaushambi",
    "Kheri",
    "Kushinagar",
    "Lalitpur",
    "Lucknow",
    "Maharajganj",
    "Mahoba",
    "Mainpuri",
    "Mathura",
    "Mau",
    "Meerut",
    "Mirzapur",
    "Moradabad",
    "Muzaffarnagar",
    "Pilibhit",
    "Pratapgarh",
    "Prayagraj",
    "Raebareli",
    "Rampur",
    "Saharanpur",
    "Sambhal",
    "Sant Kabir Nagar",
    "Shahjahanpur",
    "Shamli",
    "Shravasti",
    "Siddharthnagar",
    "Sitapur",
    "Sonbhadra",
    "Sultanpur",
    "Unnao",
    "Varanasi",
  ],
  Uttarakhand: [
    "Almora",
    "Bageshwar",
    "Chamoli",
    "Champawat",
    "Dehradun",
    "Haridwar",
    "Nainital",
    "Pauri Garhwal",
    "Pithoragarh",
    "Rudraprayag",
    "Tehri Garhwal",
    "Udham Singh Nagar",
    "Uttarkashi",
  ],
  "West Bengal": [
    "Alipurduar",
    "Bankura",
    "Birbhum",
    "Cooch Behar",
    "Dakshin Dinajpur",
    "Darjeeling",
    "Hooghly",
    "Howrah",
    "Jalpaiguri",
    "Jhargram",
    "Kalimpong",
    "Kolkata",
    "Malda",
    "Murshidabad",
    "Nadia",
    "North 24 Parganas",
    "Paschim Bardhaman",
    "Paschim Medinipur",
    "Purba Bardhaman",
    "Purba Medinipur",
    "Purulia",
    "South 24 Parganas",
    "Uttar Dinajpur",
  ],
  "Delhi (National Capital Territory)": [
    "Central Delhi",
    "East Delhi",
    "New Delhi",
    "North Delhi",
    "North East Delhi",
    "North West Delhi",
    "Shahdara",
    "South Delhi",
    "South East Delhi",
    "South West Delhi",
    "West Delhi",
  ],
};

export const CITY_STATE_MAP: Record<string, string> = Object.entries(
  STATE_CITY_MAP
).reduce((acc, [state, cities]) => {
  cities.forEach((city) => {
    if (!acc[city]) {
      acc[city] = state;
    }
  });
  return acc;
}, {} as Record<string, string>);

export const HIGHEST_EDUCATION_CATEGORIES = {
  "School Level": [
    "No Formal Education",
    "Primary School",
    "Middle School",
    "Some High School",
    "High School Diploma or Equivalent",
    "Higher Secondary / Intermediate (12th)"
  ],

  "Diploma / Certificate": [
    "Trade / Technical / Vocational Training",
    "ITI (Industrial Training Institute)",
    "Polytechnic Diploma",
    "Computer Certificate Course",
    "Professional Certification",
    "Some College Coursework Completed"
  ],

  "Undergraduate Degree": [
    "Associate Degree",
    "Bachelor's Degree",
    "B.A. (Bachelor of Arts)",
    "B.Sc (Bachelor of Science)",
    "B.Com (Bachelor of Commerce)",
    "BBA (Bachelor of Business Administration)",
    "BCA (Bachelor of Computer Applications)",

    "B.Tech in Computer Science",
    "B.Tech in Information Technology",
    "B.Tech in Electrical Engineering",
    "B.Tech in Civil Engineering",
    "B.Tech in Mechanical Engineering",

    "B.E. in Mechanical Engineering",
    "B.E. in Civil Engineering",
    "B.E. in Electrical Engineering",

    "B.Sc in Mathematics",
    "B.Sc in Physics",
    "B.Sc in Chemistry",

    "B.Com in Finance",
    "B.Com in Accounting",

    "LLB",
    "B.Ed",
    "B.Pharm",
    "B.Arch",
    "BDS"
  ],

  "Postgraduate Degree": [
    "Master's Degree",
    "M.A. (Master of Arts)",
    "M.Sc (Master of Science)",
    "M.Com (Master of Commerce)",

    "M.Tech in Computer Science",
    "M.Tech in Information Technology",
    "M.Tech in Electrical Engineering",
    "M.Tech in Mechanical Engineering",

    "MBA",
    "MBA in Marketing",
    "MBA in Finance",
    "MBA in HR",
    "MBA in Operations",

    "MCA",
    "MS (Master of Science)",
    "LLM",
    "M.Ed",
    "M.Pharm"
  ],

  "Professional Degree": [
    "Professional Degree",
    "MBBS",
    "MD",
    "MS (Medical)",
    "BAMS",
    "BHMS",
    "CA (Chartered Accountant)",
    "CS (Company Secretary)",
    "CMA (Cost & Management Accountant)",
    "CPA"
  ],

  "Doctorate & Research": [
    "Doctorate Degree",
    "Doctorate Degree (PhD)",
    "PhD in Engineering",
    "PhD in Science",
    "PhD in Arts",
    "PhD in Management",
    "Doctor of Medicine (DM)",
    "Post-Doctoral Studies"
  ]
};

export const DEGREE_OPTIONS = [
  // Undergraduate – General
  "B.A.",
  "B.Sc",
  "B.Com",
  "BBA",
  "BCA",

  // Undergraduate – Engineering / Technology
  "B.Tech",
  "B.E.",
  "B.Arch",
  "B.Des",
  "B.Pharm",
  "B.Ed",
  "LLB",

  // Undergraduate – Medical
  "MBBS",
  "BDS",
  "BAMS",
  "BHMS",
  "BPT",

  // Postgraduate – General
  "M.A.",
  "M.Sc",
  "M.Com",
  "MBA",
  "MCA",

  // Postgraduate – Engineering / Technology
  "M.Tech",
  "M.E.",
  "M.Arch",
  "M.Des",

  // Postgraduate – Medical
  "MD",
  "MS (Medical)",
  "MDS",
  "M.Pharm",
  "MPT",

  // Law
  "LLM",

  // Professional / Certification
  "CA",
  "CS",
  "CMA",
  "CPA",

  // Doctorate
  "Ph.D.",
  "DM",
  "Post-Doctoral Studies",

  // Other / Generic
  "Associate Degree",
  "Diploma",
  "Professional Degree",
];


export const FIELD_OF_STUDY_CATEGORIES = {
  "Engineering & Technology": [
    "Computer Science",
    "Information Technology",
    "Electronics & Communication",
    "Electrical Engineering",
    "Mechanical Engineering",
    "Civil Engineering",
    "Chemical Engineering",
    "Aerospace Engineering",
    "Automobile Engineering",
    "Industrial Engineering",
    "Mechatronics",
    "Robotics",
    "Artificial Intelligence",
    "Data Science",
    "Cyber Security"
  ],

  "Management & Business": [
    "Business Administration",
    "Finance",
    "Accounting",
    "Marketing",
    "Human Resources",
    "Operations",
    "International Business",
    "Entrepreneurship",
    "Supply Chain Management",
    "Project Management",
    "Hospital Management"
  ],

  "Commerce & Economics": [
    "Commerce",
    "Banking",
    "Insurance",
    "Taxation",
    "Economics"
  ],

  "Science": [
    "Science",
    "Physics",
    "Chemistry",
    "Mathematics",
    "Statistics",
    "Biotechnology",
    "Microbiology",
    "Environmental Science",
    "Life Sciences"
  ],

  "Medical & Health Sciences": [
    "Medicine",
    "Dentistry",
    "Pharmacy",
    "Nursing",
    "Physiotherapy",
    "Public Health",
    "Medical Laboratory Technology",
    "Radiology",
    "Nutrition & Dietetics"
  ],

  "Law": [
    "Law",
    "Corporate Law",
    "Criminal Law",
    "International Law",
    "Intellectual Property Law"
  ],

  "Arts & Humanities": [
    "Arts",
    "History",
    "Political Science",
    "Sociology",
    "Psychology",
    "Philosophy",
    "Geography",
    "Public Administration",
    "Journalism & Mass Communication"
  ],

  "Education & Teaching": [
    "Education",
    "Teacher Training",
    "Early Childhood Education",
    "Special Education"
  ],

  "Design & Architecture": [
    "Architecture",
    "Interior Design",
    "Fashion Design",
    "Graphic Design",
    "Industrial Design",
    "UI / UX Design"
  ],

  "Computer Applications & IT": [
    "Computer Applications",
    "Software Engineering",
    "Web Development",
    "Mobile Application Development",
    "Cloud Computing",
    "Information Systems"
  ],

  "Social Sciences": [
    "Social Work",
    "Development Studies",
    "Rural Development",
    "International Relations"
  ],

  "Others": [
    "General Studies",
    "Interdisciplinary Studies",
    "Vocational Studies",
  ]
};

export const EDUCATION_LEVEL_OPTIONS = [
  "No Formal Education",
  "School Level",
  "Higher Secondary / 12th",
  "Diploma / Certificate",
  "Undergraduate Degree",
  "Postgraduate Degree",
  "Professional Degree",
  "Doctorate & Research",
  "Post-Doctoral Studies",
];

export const OCCUPATION_CATEGORIES = {
  "IT / Software": [
    "Software Engineer",
    "Senior Software Engineer",
    "Frontend Developer",
    "Backend Developer",
    "Full Stack Developer",
    "Mobile App Developer",
    "Data Analyst",
    "Data Scientist",
    "Machine Learning Engineer",
    "AI Engineer",
    "DevOps Engineer",
    "Cloud Engineer",
    "QA / Test Engineer",
    "UI/UX Designer",
    "Product Manager",
    "Project Manager"
  ],

  "Engineering (Non-IT)": [
    "Civil Engineer",
    "Mechanical Engineer",
    "Electrical Engineer",
    "Electronics Engineer",
    "Chemical Engineer",
    "Industrial Engineer",
    "Site Engineer",
    "Quality Engineer"
  ],

  "Medical & Healthcare": [
    "Doctor",
    "Surgeon",
    "Dentist",
    "Medical Officer",
    "Pharmacist",
    "Nurse",
    "Physiotherapist",
    "Healthcare Administrator"
  ],

  "Finance / Accounting / Banking": [
    "Chartered Accountant",
    "Company Secretary",
    "Cost Accountant",
    "Banking Professional",
    "Financial Analyst",
    "Investment Banker",
    "Accounts Manager",
    "Auditor",
    "Tax Consultant"
  ],

  "Business / Entrepreneur": [
    "Business Owner",
    "Entrepreneur",
    "Startup Founder",
    "Managing Director",
    "Partner"
  ],

  "Education & Research": [
    "Teacher",
    "Professor",
    "Lecturer",
    "Research Scholar",
    "Education Consultant"
  ],

  "Government / Defence": [
    "Government Service",
    "Civil Services (IAS / IPS / IFS)",
    "Public Sector Undertaking (PSU)",
    "Defence Services",
    "Army",
    "Navy",
    "Air Force",
    "Police",
    "Paramilitary Forces"
  ],

  "Sales / Marketing / Consulting": [
    "Sales & Marketing",
    "Business Development Executive",
    "Marketing Manager",
    "Sales Manager",
    "Consultant",
    "Management Consultant"
  ],

  "Media / Creative / Design": [
    "Graphic Designer",
    "Content Writer",
    "Journalist",
    "Digital Marketer",
    "Video Editor",
    "Photographer"
  ],

  "Skilled / Technical Worker": [
    "Technician",
    "Electrician",
    "Plumber",
    "Mechanic",
    "Supervisor"
  ],

  "Others": [
    "Self Employed",
    "Freelancer",
    "Retired",
    "Student",
    "Homemaker",
    "Not working"
  ]
};


export const RELIGION_OPTIONS = [
  // Major Indian Religions
  "Hindu",
  "Muslim",
  "Christian",
  "Sikh",
  "Jain",
  "Buddhist",
  "Parsi (Zoroastrian)",
  "Jewish",

  // Indian-origin belief systems
  "Sanatan",
  "Arya Samaj",

  // Other Major World Religions
  "Baháʼí Faith",
  "Confucianism",
  "Taoism",
  "Shinto",

  // Indigenous / Tribal belief systems
  "Tribal Religion",
  "Folk Religion",

  // Modern / Belief-based
  "Spiritual but not religious",
  "Agnostic",
  "Atheist",

  // Neutral / Fallback
  "No religion",
  "Prefer not to say"
];


export const SUBCASTE_OPTIONS = [
  "Agri",
  "Ansari",
  "Arora",
  "Baidya",
  "Baniya",
  "Bhandari",
  "Bhati",
  "Bohra",
  "Brahmin",
  "Chaturvedi",
  "Chauhan",
  "Chettiar",
  "Dwivedi",
  "Ezhava",
  "Goswami",
  "Gounder",
  "Gupta",
  "Iyer",
  "Iyengar",
  "Jadeja",
  "Jain Agarwal",
  "Jat",
  "Jat Sikh",
  "Joshi",
  "Kamma",
  "Khandelwal",
  "Khatri",
  "Khoja",
  "Kokanastha",
  "Kshatriya",
  "Kumbhar",
  "Kumawat",
  "Kunbi",
  "Kurmi",
  "Kayastha",
  "Kayastha Bengali",
  "Lingayat",
  "Lodh",
  "Lohar",
  "Maheshwari",
  "Maithil Brahmin",
  "Mali",
  "Maratha",
  "Mishra",
  "Modi",
  "Nadar",
  "Nai",
  "Nair",
  "Oswal",
  "Pandit",
  "Parmar",
  "Pathan",
  "Prefer not to say",
  "Qureshi",
  "Rajput",
  "Ramgarhia",
  "Rathore",
  "Reddy",
  "Roman Catholic",
  "Saini",
  "Saraswat",
  "Sheikh",
  "Sharma",
  "Sisodia",
  "Solanki",
  "Syed",
  "Teli",
  "Thevar",
  "Tiwari",
  "Tomar",
  "Trivedi",
  "Vaishya",
  "Vokkaliga",
  "Yadav",

  // Fallbacks (keep at bottom)
  "Not Applicable",
  "Other (Please specify)"
];


export const MOTHER_TONGUE_OPTIONS = [
  // Major Indian Languages (Scheduled)
  "Assamese",
  "Bengali",
  "Bodo",
  "Dogri",
  "Gujarati",
  "Hindi",
  "Kannada",
  "Kashmiri",
  "Konkani",
  "Maithili",
  "Malayalam",
  "Manipuri (Meitei)",
  "Marathi",
  "Nepali",
  "Odia",
  "Punjabi",
  "Sanskrit",
  "Santali",
  "Sindhi",
  "Tamil",
  "Telugu",
  "Urdu",

  // Widely Spoken Regional Languages
  "Angika",
  "Awadhi",
  "Bagheli",
  "Bhojpuri",
  "Braj",
  "Chhattisgarhi",
  "Garhwali",
  "Gondi",
  "Haryanvi",
  "Kumaoni",
  "Magahi",
  "Marwari",
  "Mewari",
  "Rajasthani",
  "Shekhawati",
  "Surgujia",
  "Tulu",

  // Tribal / North-East Languages
  "Ao",
  "Garo",
  "Khasi",
  "Kokborok",
  "Lushai (Mizo)",
  "Naga Languages",

  // South Indian / Dravidian (regional)
  "Kodava",
  "Toda",
  "Badaga",

  // Minority / Others
  "Persian",
  "Arabic",
  "Tibetan",

  // Global / Common
  "English",

  // Fallbacks
  "Prefer not to say"
];


// export const MOTHER_TONGUE_OPTIONS = [
//   // Major Indian languages
//   "Hindi",
//   "English",
//   "Bengali",
//   "Telugu",
//   "Marathi",
//   "Tamil",
//   "Urdu",
//   "Gujarati",
//   "Kannada",
//   "Odia",
//   "Malayalam",
//   "Punjabi",
//   "Assamese",
//   "Maithili",

//   // Regional languages
//   "Rajasthani",
//   "Bhojpuri",
//   "Haryanvi",
//   "Chhattisgarhi",
//   "Konkani",
//   "Tulu",
//   "Kodava",
//   "Bodo",
//   "Santhali",
//   "Dogri",
//   "Kashmiri",
//   "Sindhi",
//   "Manipuri (Meitei)",
//   "Mizo",
//   "Khasi",
//   "Garo",

//   // Others
//   "Nepali",
//   "Tibetan",
//   "Other"
// ];


export const NAKSHATRA_OPTIONS = [
  "Ashwini",
  "Bharani",
  "Krittika",
  "Rohini",
  "Mrigashirsha",
  "Ardra",
  "Punarvasu",
  "Pushya",
  "Ashlesha",
  "Magha",
  "Purva Phalguni",
  "Uttara Phalguni",
  "Hasta",
  "Chitra",
  "Swati",
  "Vishakha",
  "Anuradha",
  "Jyeshtha",
  "Mula",
  "Purva Ashadha",
  "Uttara Ashadha",
  "Shravana",
  "Dhanishta",
  "Shatabhisha",
  "Purva Bhadrapada",
  "Uttara Bhadrapada",
  "Revati"
];

export const RAASHI_OPTIONS = [
  "Mesh (Aries)",
  "Vrishabh (Taurus)",
  "Mithun (Gemini)",
  "Kark (Cancer)",
  "Singh (Leo)",
  "Kanya (Virgo)",
  "Tula (Libra)",
  "Vrishchik (Scorpio)",
  "Dhanu (Sagittarius)",
  "Makar (Capricorn)",
  "Kumbh (Aquarius)",
  "Meen (Pisces)"
];

export const ASTROLOGY_SYSTEM_OPTIONS = [
  "Vedic (Hindu Astrology)",
  "KP (Krishnamurti Paddhati)",
  "Western Astrology",
  "Chinese Astrology",
  "Nadi Astrology",
];

export const HOROSCOPE_PREFERENCE_OPTIONS = [
  "Match required",
  "Match preferred but not mandatory",
  "Not important",
  "Does not believe in horoscope"
];

export const DOSHA_DETAIL_OPTIONS = [
  "Mangal Dosha (Manglik)",
  "Partial Manglik",
  "Shani Dosha",
  "Kala Sarpa Dosha",
  "Rahu Dosha",
  "Ketu Dosha",
  "Pitra Dosha",
  "Guru Chandal Dosha",
  "No Dosha",
];


export const GOTRA_OPTIONS = [
  // A
  "Agastya",
  "Aitareya",
  "Angiras",
  "Atri",
  "Atreya",

  // B
  "Bharadwaj",
  "Bharadvaja",
  "Bhargava",
  "Bhrigu",
  "Bhaskar",
  "Bodhayana",

  // C
  "Chandratreya",
  "Chyavana",

  // D
  "Dhananjaya",
  "Dhaumya",
  "Dirghatamas",

  // G
  "Garga",
  "Gargya",
  "Gautam",
  "Ghosh",
  "Gokarna",

  // H
  "Harita",
  "Hiranyakeshi",

  // J
  "Jaimini",
  "Jamadagni",
  "Jatukarna",

  // K
  "Kanha",
  "Kanva",
  "Kapila",
  "Kashyap",
  "Kanshyapa",
  "Katyayan",
  "Kaushik",
  "Koundinya",
  "Krishna Atreya",
  "Kutsa",

  // L
  "Lohita",
  "Lomesh",

  // M
  "Mandavya",
  "Marichi",
  "Markandeya",
  "Maudgalya",
  "Mudgala",

  // N
  "Narada",
  "Nishad",

  // P
  "Panchala",
  "Parasara",
  "Parashara",
  "Paushyan",
  "Pippalada",
  "Pulaha",
  "Pulastya",

  // R
  "Raghava",
  "Rishi Kashyap",
  "Rishi Vashishtha",

  // S
  "Sandilya",
  "Shaunaka",
  "Shandilya",
  "Shringi",
  "Shukla",
  "Sudarshana",
  "Sankhyayan",
  "Satyayani",

  // T
  "Trivedi",
  "Taittiriya",

  // U
  "Upamanyu",
  "Uddalaka",

  // V
  "Vainya",
  "Vashishtha",
  "Vatsa",
  "Vishnu",
  "Vishwamitra",
  "Vyasa",

  // Y
  "Yajnavalkya",

  // Vaishya / Jain commonly used
  "Agarwal",
  "Oswal",
  "Porwal",
  "Maheshwari",
  "Khandelwal",
  "Goyal",
  "Singhal",
  "Mittal",
  "Jain",

  // Regional / Community-used names
  "JhunJhunodiya",
  "Nagarkoti",
  "Bansal",
  "Tayal",
  "Rawat",
  "Shekhawat",
  "Chauhan",
  "Rathore",
  "Sisodia",

  // Generic / fallback (VERY IMPORTANT)
  "Not Applicable",
];


export const HEIGHT_OPTIONS = [
  "4'6\"","4'7\"","4'8\"","4'9\"","4'10\"","4'11\"",
  "5'0\"","5'1\"","5'2\"","5'3\"","5'4\"","5'5\"",
  "5'6\"","5'7\"","5'8\"","5'9\"","5'10\"","5'11\"",
  "6'0\"","6'1\"","6'2\"","6'3\"","6'4\"","6'5\"",
  "6'6\"","6'7\"","6'8\""
];

export const ANNUAL_INCOME_OPTIONS = [
  "No income",
  "Less than 1 LPA",
  "1 - 3 LPA",
  "3 - 5 LPA",
  "5 - 7 LPA",
  "7 - 10 LPA",
  "10 - 15 LPA",
  "15 - 20 LPA",
  "20 - 25 LPA",
  "25 - 30 LPA",
  "30 - 40 LPA",
  "40 - 50 LPA",
  "50 - 75 LPA",
  "75 LPA - 1 Cr",
  "1 Cr - 2 Cr",
  "2 Cr - Above"
];

export const FAMILY_BACKGROUND_OPTIONS = [
  // Economic background
  "Lower middle class",
  "Middle class",
  "Upper middle class",
  "Affluent / Wealthy",

  // Occupation-based background
  "Business family",
  "Service class family",
  "Professional family",
  "Agricultural / farming family",
  "Self-employed family",

  // Cultural & social background
  "Traditional family background",
  "Moderate family background",
  "Liberal / modern family background",
  "Culturally rooted family",

  // Living & upbringing
  "Simple living background",
  "Urban family background",
  "Semi-urban family background",
  "Rural family background",

  // Neutral / fallback
  "Mixed background",
  "No specific background",
  "Other"
];

export const FAMILY_TYPE_OPTIONS = [
  "Joint family",
  "Nuclear family",
  "Extended family",
  "Living with parents",
  "Living separately",
  "Single parent family",

  // Modern / flexible
  "Flexible family setup",
  "Depends on circumstances",

  // Neutral / fallback
  "No preference",
  "Other"
];

export const FAMILY_VALUES_OPTIONS = [
  // Core value spectrum
  "Traditional",
  "Moderate",
  "Liberal",
  "Progressive",

  // Relationship & bonding
  "Family-oriented",
  "Strong family bonding",
  "Close-knit family",
  "Supportive family",
  "Respect for elders",

  // Culture & beliefs
  "Culturally rooted",
  "Religious / spiritual values",
  "Festival and tradition oriented",
  "Community-oriented",

  // Lifestyle & mindset
  "Modern outlook with traditional roots",
  "Balanced traditional and modern values",
  "Open-minded family",
  "Independent yet family-focused",

  // Ethics & priorities
  "Honest and ethical values",
  "Disciplined lifestyle",
  "Education and career oriented",
  "Value simplicity",

  // Living & structure
  "Joint family values",
  "Nuclear family values",
  "Flexible family values",

  // Neutral / fallback
  "No specific family values",
  "Other"
];


// export const FAMILY_BACKGROUND_OPTIONS = [
//   "Lower middle class",
//   "Middle class",
//   "Upper middle class",
//   "Affluent",
//   "Business family",
//   "Service class family",
//   "Joint family",
//   "Nuclear family",
//   "Traditional",
//   "Moderate",
//   "Liberal"
// ];


export const SIBLINGS_OPTIONS = [
  "No siblings",
  "Younger Brother",
  "Younger Sister",
  "Elder Brother",
  "Elder Sister",
  "Step Brother",
  "Step Sister"
];

export const SPECIAL_NOTE_OPTIONS = [
  "No disability, healthy and fit",
  "Minor vision issue (uses glasses)",
  "Minor hearing issue",
  "Physically challenged",
  "Speech impairment",
  "Chronic medical condition",
  "Other health details (will share on call)",
  "Prefer not to disclose"
];


export const LIFESTYLE_HABIT_OPTIONS = [
  "Vegetarian",
  "Non-vegetarian",
  "Eggetarian",
  "Vegan",
  "Occasionally non-veg",

  "Does not drink",
  "Occasionally drinks",
  "Drinks socially",

  "Does not smoke",
  "Occasionally smokes",
  "Regular smoker"
];

export const ASSET_OPTIONS = [
  "Own house",
  "Rented house",
  "Own flat / apartment",
  "Family house",
  "Own car",
  "Own two-wheeler",
  "Agricultural land",
  "Commercial property",
  "Inherited property",
  "No property"
];


export const HOBBY_OPTIONS = [
  "Reading",
  "Traveling",
  "Music",
  "Movies",
  "Cooking",
  "Photography",
  "Drawing / Painting",
  "Dancing",
  "Singing",
  "Writing",
  "Gardening",
  "DIY crafts",
  "Sports / fitness"
];


export const INTEREST_OPTIONS = [
  "Spirituality",
  "Technology",
  "Startups",
  "Business & entrepreneurship",
  "Art & culture",
  "Finance & investing",
  "Social work / volunteering",
  "Politics",
  "Environment & sustainability",
  "Health & wellness"
];

export const MUSIC_OPTIONS = [
  "Bollywood",
  "Hollywood / English",
  "Indian classical",
  "Devotional / bhajans",
  "Indie music",
  "Soft rock",
  "Pop",
  "Jazz",
  "Instrumental"
];



export const CUISINE_OPTIONS = [
  "North Indian",
  "South Indian",
  "Gujarati",
  "Rajasthani",
  "Punjabi",
  "Chinese",
  "Italian",
  "Continental",
  "Mexican",
  "Thai",
  "Street food"
];

export const CLOTHING_STYLE_OPTIONS = [
  "Mostly traditional",
  "Mostly western",
  "Mix of traditional & western",
  "Comfort-first dressing",
  "Formal / professional",
  "Casual wear"
];

export const SPORTS_FITNESS_OPTIONS = [
  "Gym / fitness",
  "Running / jogging",
  "Yoga / meditation",
  "Cricket",
  "Badminton",
  "Football",
  "Cycling",
  "Swimming",
  "Trekking",
  "Home workouts"
];

export const COOKING_OPTIONS = [
  "Yes, love cooking",
  "Can cook basic dishes",
  "Learning to cook",
  "Rarely cook",
  "Prefer ordering in"
];


export const TRAVEL_STYLE_OPTIONS = [
  "Weekend getaways",
  "Road trips",
  "International travel",
  "Pilgrimage trips",
  "Beach holidays",
  "Hill stations",
  "Adventure travel",
  "Staycations"
];


export const FAVOURITE_SHOWS_OPTIONS = [
  "Bollywood movies",
  "Hollywood movies",
  "Regional movies",
  "Web series",
  "Sitcoms / comedy shows",
  "Documentaries",
  "Reality shows",
  "News & debates"
];

export const BOOK_OPTIONS = [
  "Fiction novels",
  "Non-fiction",
  "Self-help books",
  "Biographies",
  "Spiritual books",
  "Business / startup books",
  "Educational / academic books"
];

export const OUTDOOR_ACTIVITY_OPTIONS = [
  "Trekking",
  "Cycling",
  "Nature walks",
  "Photography walks",
  "Running",
  "Camping"
];

export const INDOOR_ACTIVITY_OPTIONS = [
  "Board games",
  "Watching movies",
  "Cooking / baking",
  "Reading at home",
  "Meditation",
  "Music practice"
];

export const VALUE_OPTIONS = [
  "Family-oriented",
  "Honest",
  "Kind",
  "Ambitious",
  "Spiritual",
  "Open-minded",
  "Respectful",
  "Career-focused"
];

export const WEEKEND_OPTIONS = [
  "Relaxing at home",
  "Spending time with family",
  "Exploring new cafes / restaurants",
  "Short trips / drives",
  "Meeting friends",
  "Pursuing hobbies"
];

export const PROFILE_HEADLINE_OPTIONS = [
  "Looking for a life partner",
  "Simple and family-oriented",
  "Career focused, family values",
  "Kind-hearted and respectful",
  "Fun-loving and optimistic",
  "Serious about marriage",
  "Modern thinking with traditional values",
  "Down to earth and caring",
  "Ambitious and supportive",
  "Honest, humble and loyal",
];

export const KUNDLI_ASTRO_PREFERENCE_OPTIONS = [
  "Match required",
  "Match preferred",
  "Doesn't matter",
  "Not important",
  "Will discuss later",
];

export const PARTNER_MARITAL_STATUS_OPTIONS = [
  "Unmarried",
  "Divorced",
  "Widowed",
  "Separated",
  "Any"
];

export const PARTNER_HEIGHT_RANGE_OPTIONS = [
  "4'8\" - 5'2\"",
  "5'0\" - 5'6\"",
  "5'3\" - 5'9\"",
  "5'5\" - 6'0\"",
  "5'8\" - 6'2\"",
  "6'2\" - 6'8\""
];

export const PARTNER_AGE_RANGE_OPTIONS = [
  "18 - 22 years",
  "22 - 26 years",
  "24 - 28 years",
  "26 - 30 years",
  "28 - 32 years",
  "30 - 35 years",
  "35 - 40 years",
  "40 - Above"
];


export const DIET_OPTIONS = [
  "Vegetarian",
  "Non-vegetarian",
  "Eggetarian",
  "Vegan",
  "Jain food only",
  "No specific preference"
];

export const SMOKING_OPTIONS = [
  "Non-smoker",
  "Occasionally smokes",
  "Regular smoker",
  "Does not matter"
];

export const DRINKING_OPTIONS = [
  "Does not drink",
  "Occasionally drinks",
  "Drinks socially",
  "Regular drinker",
  "Does not matter"
];

export const COUNTRY_OPTIONS = [
  "India",

  // North America
  "United States",
  "Canada",

  // Europe
  "United Kingdom",
  "Germany",
  "France",
  "Italy",
  "Spain",
  "Netherlands",
  "Switzerland",
  "Ireland",

  // Middle East
  "United Arab Emirates",
  "Saudi Arabia",
  "Qatar",
  "Kuwait",
  "Oman",
  "Bahrain",

  // Asia-Pacific
  "Australia",
  "New Zealand",
  "Singapore",
  "Malaysia",
  "Thailand",
  "Indonesia",

  // South Asia
  "Nepal",
  "Bhutan",
  "Sri Lanka",
  "Bangladesh",

  // Other
  "South Africa",
  "Japan",
  "South Korea",
];


export const CITY_SUGGESTIONS = [
  // Metro & Tier-1
  "Delhi",
  "Mumbai",
  "Bengaluru",
  "Chennai",
  "Kolkata",
  "Hyderabad",
  "Pune",
  "Ahmedabad",

  // North India
  "Agra",
  "Jaipur",
  "Jodhpur",
  "Kota",
  "Sikar",
  "Lucknow",
  "Kanpur",
  "Varanasi (Benaras)",
  "Meerut",
  "Ghaziabad",
  "Amritsar",
  "Ludhiana",
  "Jalandhar",
  "Chandigarh",
  "Srinagar",

  // West India
  "Surat",
  "Vadodara",
  "Rajkot",
  "Nashik",
  "Nagpur",
  "Aurangabad",
  "Navi Mumbai",
  "Thane",

  // Central India
  "Bhopal",
  "Indore",
  "Gwalior",
  "Jabalpur",
  "Raipur",

  // East India
  // "Kolkata",
  "Howrah (Haora)",
  "Ranchi",
  "Jamshedpur",
  "Patna",
  "Bhubaneswar",
  "Guwahati",

  // South India
  // "Chennai",
  "Coimbatore",
  "Madurai",
  "Kochi",
  "Thiruvananthapuram",
  "Mysore (Mysuru)",
  "Vijayawada",
  "Visakhapatnam (Vizag)",
  
  // "Hyderabad",
  // "Bengaluru",
];

